



































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import ChangePlanModal from '@/components/organizationConfig/configList/ChangePlanModal.vue';
import { CreateOrganizationResult } from '@/@types/Organization';
import { ORGANIZATION_BILLING_PLAN } from '@/@types/constant';
import { vxm } from '@/store';

@Component({
  components: {
    ChangePlanModal,
  },
})
export default class UsagePlan extends Vue {
  private selectPlan: string = '';
  private usagePlan: string = '';
  private isOpenChangePlanModal: boolean = false;
  private selectedOrganization: CreateOrganizationResult = {
    organizationId: 0,
    organizationName: "",
    organizationIcon: "",
    organizationComment: "",
    sectorCd: "",
    billingPlan: "",
    organizationEmail: "",
    organizationPhoneNumber: "",
    organizationPerson: "",
    prefectureCd: "",
    cityCd: "",
    organizationStreetAddress: "",
    deleteFlag: false,
  };
  private BILLING_PLAN = ORGANIZATION_BILLING_PLAN;

  private async created() {
    await vxm.theoryApi.organizationsStore.findOneOrganization(vxm.theoryApi.authStore.getCurrentOrganizationId!);
    this.refreshOrganizationInfo();
  }

  private closeChangePlanModal(isOpenChangePlanModal: boolean) {
    this.refreshOrganizationInfo();
    this.isOpenChangePlanModal = isOpenChangePlanModal;
  }

  private refreshOrganizationInfo() {
    this.selectedOrganization = vxm.theoryApi.organizationsStore.getOrganization;
    this.usagePlan = this.selectedOrganization.billingPlan;
  }
}
